var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-immunization-checklist.6b6ceb32.png","uri@2x": __webpack_public_path__ + "icon-immunization-checklist.85d81d43.png","uri@3x": __webpack_public_path__ + "icon-immunization-checklist.8860b56d.png",
    width: 33,
    height: 38
});